import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

/**
 * Quick suggestion buttons shown when the chat is empty.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'services',
    labelKey: 'chatbot.suggestions.services',
    messageKey: 'chatbot.suggestions.servicesMessage',
  },
  {
    id: 'assistance',
    labelKey: 'chatbot.suggestions.assistance',
    messageKey: 'chatbot.suggestions.assistanceMessage',
  },
  {
    id: 'brands',
    labelKey: 'chatbot.suggestions.brands',
    messageKey: 'chatbot.suggestions.brandsMessage',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 */
export const contactCTAs: ContactCTA[] = [
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 011 9038412',
  },
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@labinstruments.it',
  },
]
